import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {blue600, white} from 'material-ui/styles/colors';

const themeDefault = getMuiTheme({
    palette: {},
    appBar: {
        height: 57,
        color: blue600
    },
    drawer: {
        width: 230,
        color: white

    },
    raisedButton: {
        primaryColor: blue600
    }
});

export default themeDefault;



// WEBPACK FOOTER //
// src/styles/theme-default.js